import { useEffect, useState, useCallback } from 'react'

export function useKonamiTapper({ enabled = false }: { enabled: boolean }) {
  const [tapCount, setTapCount] = useState(0)
  const [isKonamiMaster, setKonamiMaster] = useState(enabled)
  const [tapTimeout, setTapTimeout] = useState<NodeJS.Timeout | null>(null)

  useEffect(() => {
    return () => {
      if (tapTimeout) {
        clearTimeout(tapTimeout)
      }
    }
  }, [tapTimeout])

  const increaseTapCount = useCallback(() => {
    if (isKonamiMaster) return

    if (tapCount >= 9) {
      setTapCount(0)
      setKonamiMaster(true)
    } else {
      if (!tapTimeout) {
        const timeout = setTimeout(() => {
          setTapCount(0)
          setTapTimeout(null)
        }, 3000)
        setTapTimeout(timeout)
      }
      setTapCount((previousTapCount) => previousTapCount + 1)
    }
  }, [isKonamiMaster, tapCount, tapTimeout, setKonamiMaster, setTapCount, setTapTimeout])

  return {
    isKonamiMaster,
    increaseTapCount,
  }
}
